import { get, post, del } from '../../ReaderlyHttpClient';

export interface WaitlistStatus {
  inQueue: boolean;
  position: number | null;
  queueLength: number;
}

class WaitlistService {
  async GetStatus(itemId: number) {
    return await get<WaitlistStatus>(`/waitlist/${itemId}`, undefined, { suppressGlobalError: true });
  }

  async Join(itemId: number) {
    return await post<void, undefined>(`/waitlist/${itemId}`, undefined);
  }

  async Leave(itemId: number) {
    return await del<void>(`/waitlist/${itemId}`);
  }
}

const waitlistServiceInstance = new WaitlistService();

export default waitlistServiceInstance;
